(ns global.endor.checkout.ui.core
  (:require [uix.core :as uix :refer [$ defui]]
            [global.endor.checkout.ui.components.basics :as ui]
            [global.endor.checkout.ui.components.waiting :as waiting]
            [global.endor.checkout.ui.style.colors :as colors]))

(defui container [{:keys [children style]}]
  ($ :div
     {:style (ui/styles
              {:background-color (colors/background :primary)
               :min-height "100vh"}
              style)}
     children))

(defui root []
  ($ waiting/waiting-screen
     {:message "Under construction..."}))
